import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      plugins: ['remove_button', 'dropdown_input'],
      placeholder: this.selectTarget.getAttribute('placeholder') || 'Choose a Document Type',
      closeAfterSelect: false,
      hideSelected: true,
      maxOptions: null
    })

    this.tomSelect.on('dropdown_open', () => {
      this.tomSelect.dropdown.addEventListener('keydown', this.handleKeyboardScroll)
    })

    this.tomSelect.on('dropdown_close', () => {
      this.tomSelect.dropdown.removeEventListener('keydown', this.handleKeyboardScroll)
    })

    this.applyErrorState()
  }

  disconnect() {
    if (this.tomSelect) {
      if (this.tomSelect.dropdown) {
        this.tomSelect.dropdown.removeEventListener('keydown', this.handleKeyboardScroll)
      }
      this.tomSelect.destroy()
      this.tomSelect = null
    }
  }

  handleKeyboardScroll = (e) => {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      setTimeout(() => {
        const active = this.tomSelect.dropdown.querySelector('.option.active')
        if (active) {
          active.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      }, 0)
    }
  }

  applyErrorState() {
    if (this.selectTarget.classList.contains('input-error')) {
      this.tomSelect.wrapper.querySelector('.ts-control').classList.add('error')
    }
  }
}
